module.exports = __webpack_public_path__ + "img/pin-silver.23762ed0.png";